import { useTranslation } from "react-i18next";
import { CheckCircle2, Loader2, MinusCircle, XCircle } from "lucide-react";

import { runOutcome } from "../utils/runs";

/**
 * O status da última execução num ícone: verde concluída, âmbar em andamento,
 * vermelho com falha, cinza cancelada. O ícone muda de forma além da cor, para
 * não depender só dela; o nome do status vem no tooltip.
 */
export function JobRunStatusIcon({ status }: { status: string }) {
  const { t } = useTranslation();
  const outcome = runOutcome(status);
  const label = t(
    outcome === "live"
      ? status === "waiting"
        ? "jobs.runs.status.waiting"
        : "jobs.runs.status.running"
      : `jobs.runs.status.${outcome}`,
  );
  const common = { className: "h-4 w-4 shrink-0", "aria-label": label };

  return (
    <span title={label} className="inline-flex">
      {outcome === "completed" ? (
        <CheckCircle2 {...common} className={`${common.className} text-green-600 dark:text-green-500`} />
      ) : outcome === "live" ? (
        <Loader2 {...common} className={`${common.className} animate-spin text-amber-500`} />
      ) : outcome === "cancelled" ? (
        <MinusCircle {...common} className={`${common.className} text-muted-foreground`} />
      ) : (
        <XCircle {...common} className={`${common.className} text-destructive`} />
      )}
    </span>
  );
}
